import { Button, Flex, Box, Title, Text } from "@shared/primitive-components"
import { LogoBlock } from "./LogoBlock"
import { container } from "./styles/authStyles"
import * as styles from "./styles/unauthorizedStyles"

interface Props {
  onLogoutClick: () => Promise<void>
  text: string
}

export const Unauthorized = ({ onLogoutClick, text }: Props) => (
  <Flex css={container}>
    <Flex css={styles.contentContainer}>
      <Title css={styles.title}>Oops!</Title>
      <Flex>
        <Text>{text}</Text>
      </Flex>
      <Box css={styles.margin} />
      <Flex css={styles.buttonWrapper}>
        <Button type="submit" onClick={onLogoutClick}>
          Log out
        </Button>
      </Flex>
    </Flex>
    <LogoBlock />
  </Flex>
)
